import { postRequest } from 'src/services/requests';

const carregarNomesLogicos = (
  NomesLogicos: string[]
): Promise<{ success: boolean; messages: string[]; data: object }> => {
  return new Promise((resolve, reject) => {
    postRequest(
      `/genericos/ge/NomeLogicoUsuario/CarregarNomesLogicos`,
      { NomesLogicos },
      resolve,
      reject
    );
  });
};

export { carregarNomesLogicos };
